import { combineReducers } from 'redux';
import summaries from './failure-summaries';

export default combineReducers({
  summaries,
});
